import { ACCOUNT_API_HOST } from "config";
import { HttpAPi } from "shared/http-api";

export const accountHttpApi = HttpAPi(ACCOUNT_API_HOST);

export type SignupFieldsT = {
  email: string,
  phoneNumber: string,
  password: string,
  name: string,
  token: string
}

export async function signup (fields: SignupFieldsT) {
  const res = await accountHttpApi.makeRequest('/users', {
    body: fields,
    method: 'POST'
  });
  return res.json();
}

export type LoginFieldsT = { identifier: string, password: string } | { identifier: string, code: string };

export async function login (fields: LoginFieldsT) {
  const res = await accountHttpApi.makeRequest<{ expiresAt: number, token: string }>('/users/login', {
    body: fields,
    method: 'POST'
  });
  return res.json();
}

export type LoginCodeFieldsT = { email: string, token: string } | { phoneNumber: string, token: string }

export async function sendLoginCode (fields: LoginCodeFieldsT) {
  const res = await accountHttpApi.makeRequest<{ expiresAt: string }>('/users/login-code', {
    body: fields,
    method: 'POST'
  });
  return res.json();
}

export async function getGoogleOauthUrl (state: Record<string,string>) {
  const res = await accountHttpApi.makeRequest<{ redirectUrl: string }>(
    '/federated-auth/google',
    { method: 'POST', body: { state }, credentials: "include" }
  );
  return res.json();
}

export type GoogleOauthCallbackFieldsT = { scope?: string, code: string, state?: string, error?: string }

export async function postGoogleOauthCallback ({ scope, code, state, error }: GoogleOauthCallbackFieldsT) {
  const urlSearchParams = new URLSearchParams([
    ['scope', scope || ''],
    ['code', code || ''],
    ['state', state || ''],
    ['error', error || '']
  ])
  const url = `/federated-auth/google/callback?${urlSearchParams.toString()}`
  const res = await accountHttpApi.makeRequest<{ tokenInfo: { expiresAt: number, token: string }, state: Record<string,string> }>(url, { method: 'POST', credentials: "include" });
  return res.json();
}

export type PasswordResetCodeFieldsT = { identifier: string, token: string }

export async function sendPasswordResetCode (fields: PasswordResetCodeFieldsT) {
  const res = await accountHttpApi.makeRequest<{ expiresAt: string, isEmail: boolean }>('/users/password-reset-code', {
    body: fields,
    method: 'POST'
  });
  return res.json();
}

export async function patchUserPassword (fields: { identifier: string, password: string, code: string }) {
  const res = await accountHttpApi.makeRequest<{ expiresAt: string, isEmail: boolean }>('/users/password', {
    body: fields,
    method: 'POST'
  });
  return res.json();
}
